import { useSetAtom } from "jotai"
import { GetRequest } from "../../../common/api"
import { urls, xlCol, xlColq } from "../../../common/constants"
import { alertAtom } from "../../../common/jotaiState/globalStateAtoms"
import moment from "moment"
export const branchwiseColumnDefs = [
    { header: 'SN', dataKey: 'SN', xlCol: xlColq, headerSx: { width: '4%', textAlign: 'center' } },
    { header: 'Transaction\nDate', dataKey: 'TransactionDate', xlCol: xlCol, headerSx: { width: '9%', textAlign: 'left' } },
    { header: 'Opening\nBalance', dataKey: 'OpeningBalance', xlCol: xlColq, headerSx: { width: '8%', textAlign: 'right' } },
    { header: 'COD\nAdjusted', dataKey: 'CODAmount', xlCol: xlColq, headerSx: { width: '7%', textAlign: 'right' } },
    { header: 'Paid\nAmount', dataKey: 'PaidAmount', xlCol: xlColq, headerSx: { width: '7%', textAlign: 'right' } },
    { header: 'Total Revenue\nCollected', dataKey: 'TotalRevCollected', xlCol: xlColq, headerSx: { width: '9%', textAlign: 'right' } },
    { header: 'LL Delivery &\nCollection', dataKey: 'LLDeliveryCollection', xlCol: xlColq, headerSx: { width: '9%', textAlign: 'right' } },
    { header: 'LL Jumia\nAmount', dataKey: 'LLJumiaAmount', xlCol: xlColq, headerSx: { width: '7%', textAlign: 'right' } },
    { header: 'LL KEMSA\nDistribution', dataKey: 'LLKEMSADistribution', xlCol: xlColq, headerSx: { width: '8%', textAlign: 'right' } },
    { header: 'Total Expense\nIncurred', dataKey: 'TotalExpenseIncurred', xlCol: xlColq, headerSx: { width: '8%', textAlign: 'right' } },
    { header: 'Net Revenue To\nBe Banked', dataKey: 'NetRevenueToBeBanked', xlCol: xlColq, headerSx: { width: '9%', textAlign: 'right' } },
    { header: 'Mpesa\nCollection', dataKey: 'MpesaCollection', xlCol: xlColq, headerSx: { width: '7%', textAlign: 'right' } },
    { header: 'Cheque / Direct\nDeposits', dataKey: 'ChequeDirectDeposits', xlCol: xlColq, headerSx: { width: '8%', textAlign: 'right' } },
    { header: 'Total\nBanking', dataKey: 'TotalBanking', xlCol: xlColq, headerSx: { width: '7%', textAlign: 'right' } },
    { header: 'Unbanked Cash\nVariance', dataKey: 'UnbankedCash', xlCol: xlColq, headerSx: { width: '8%', textAlign: 'right' } },
    { header: 'Closing\nBalance', dataKey: 'ClosingBalance', xlCol: xlColq, headerSx: { width: '7%', textAlign: 'right' } },
]

export const userwiseColumnDefs = [
  { header: 'SN', dataKey: 'SN', xlCol: xlColq, headerSx: { width: '5%', textAlign: 'center' } },
  { header: 'Transaction\nDate', dataKey: 'TransactionDate', xlCol: xlCol, headerSx: { width: '10%', textAlign: 'left' } },
  { header: 'Opening\nBalance', dataKey: 'OpeningBalance', xlCol: xlColq, headerSx: { width: '8%', textAlign: 'right' } },
  { header: 'COD\nAdjusted', dataKey: 'CODAmount', xlCol: xlColq, headerSx: { width: '7%', textAlign: 'right' } },
  { header: 'Paid\nAmount', dataKey: 'PaidAmount', xlCol: xlColq, headerSx: { width: '7%', textAlign: 'right' } },
  { header: 'Total Revenue\nCollected', dataKey: 'TotalRevCollected', xlCol: xlColq, headerSx: { width: '9%', textAlign: 'right' } },
  { header: 'LL Delivery\nExpense', dataKey: 'LLDeliveryExpense', xlCol: xlColq, headerSx: { width: '8%', textAlign: 'right' } },
  { header: 'LL Other\nExpense', dataKey: 'LLOtherExpense', xlCol: xlColq, headerSx: { width: '8%', textAlign: 'right' } },
  { header: 'Total Expense\nIncurred', dataKey: 'TotalExpenseIncurred', xlCol: xlColq, headerSx: { width: '8%', textAlign: 'right' } },
  { header: 'Net Revenue\nTo Be Banked', dataKey: 'NetRevenueToBeBanked', xlCol: xlColq, headerSx: { width: '9%', textAlign: 'right' } },
  { header: 'Mpesa\nCollection', dataKey: 'MpesaCollection', xlCol: xlColq, headerSx: { width: '7%', textAlign: 'right' } },
  { header: 'Cheque /\nDirect', dataKey: 'ChequeDirectDeposits', xlCol: xlColq, headerSx: { width: '7%', textAlign: 'right' } },
  { header: 'Total\nBanking', dataKey: 'TotalBanking', xlCol: xlColq, headerSx: { width: '7%', textAlign: 'right' } },
  { header: 'Unbanked Cash\nVariance', dataKey: 'UnbankedCash', xlCol: xlColq, headerSx: { width: '8%', textAlign: 'right' } },
  { header: 'Closing\nBalance', dataKey: 'ClosingBalance', xlCol: xlColq, headerSx: { width: '7%', textAlign: 'right' } },
]
 
   export const getBranchWiseBalanceReportData = async (body, setAlert) => {
    try {
       const res = await GetRequest(urls.branchWiseBalanceSummary, body)
   
       if (res.status !== 'Success') {
         setAlert({ show: true, msg: res?.ErrMessage, nextId: '' })
      return
        }
   
       const tableData = res?.Data?.Table || []
   
       const reportData = tableData.map((val, i) => ({
         ...val,
         SN: i + 1,
         dataType: 'entry',
         TransactionDate: moment(new Date(val.TransactionDate)).format('DD-MM-YYYY'),
       }))
   
       return reportData
     } catch (error) {
       setAlert({ show: true, msg: error?.message, nextId: '' })
     }
   }
    export const getUserWiseBalanceReportData = async (body, setAlert) => {
    try {
       const res = await GetRequest(urls.userWiseBalanceSummary, body)
   
       if (res.status !== 'Success') {
         setAlert({ show: true, msg: res?.ErrMessage, nextId: '' })
      return
        }
   
       const tableData = res?.Data?.Table || []
   
       const reportData = tableData.map((val, i) => ({
         ...val,
         SN: i + 1,
         dataType: 'entry',
         TransactionDate: moment(new Date(val.TransactionDate)).format('DD-MM-YYYY'),
       }))
   
       return reportData
     } catch (error) {
       setAlert({ show: true, msg: error?.message, nextId: '' })
     }
   }

